import React from "react";
import { objToFormData } from "../../../helpers/FormHelper";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { createCategory, fetchCategories } from "../../../actions/mine_craft/categoriesActions";
import { setNewParams, setNewError } from "../../../store/mine_craft/categoriesSlice";

import DrawerRight from "../../../componets/DrawerRight";
import Form from './_partials/_Form';
import AlertBlock from "../../../componets/AlertBlock";

const New = () => {
  const dispatch  = useAppDispatch();
  const params    = useAppSelector(state => state.mineCraft.categories.newParams);
  const error     = useAppSelector(state => state.mineCraft.categories.newError);

  function onCloseError() {
    dispatch(setNewError(null));
  }

  function onClose() {
    dispatch(setNewParams(null));
  }

  function onFinish(data: object) {
    const formData = objToFormData(data);
    handleSave(formData).catch(console.error);
  }

  async function handleSave(data: object) {
    const resultAction = await dispatch(createCategory(data));

    if (createCategory.fulfilled.match(resultAction)) {
      dispatch(fetchCategories({ target_id: params?.target_id }));
      onClose();
    }
  }

  return (
    <DrawerRight
      open={!!params}
      onClose={onClose}
      getContainer='.v-layout--body'
    >
      <div className='v-new-skin'>
        <h6 className="v-content-label">Create Category</h6>

        <AlertBlock type='error' message={error} onClose={onCloseError} />

        <Form onFinish={onFinish} params={params} />
      </div>
    </DrawerRight>
  )
}

export default New;
